import Player from '@vimeo/player';

const vimeo = {
  init: function() {
    this.stateOfVimeo();
    this.behaviorOfBtn();
    this.mouseLeaveVimeo();
  },
  behaviorOfBtn: function() {
    const btn = document.querySelector('.video-play');
    const video = document.querySelector('.video')

    video.addEventListener('mousemove', (e) => {
      const mouseX = e.clientX;
      const mouseY = e.clientY;


      const moveX = Math.abs(( mouseX - (video.offsetWidth / 2) ) - video.getBoundingClientRect().left);
      const moveY = Math.abs(( mouseY - (video.offsetHeight / 2) ) - video.getBoundingClientRect().top);

      const reverseX = Math.abs(moveX - video.offsetWidth);
      const reverseY = Math.abs(moveY - video.offsetHeight);

      const resultX = (reverseX / video.offsetWidth).toFixed(2) * 1;
      const resultY = (reverseY / video.offsetHeight).toFixed(2) * 1;

      console.log();

      btn.style.opacity = `${(resultX + resultY) / 2}`;
    });
  },
  mouseLeaveVimeo: function() {
    const video = document.querySelector('.video')
    const btn = document.querySelector('.video-play');


    video.addEventListener('mouseleave', () => {
      btn.style.opacity = 0;
    })
  },
  stateOfVimeo: function() {
    const iframe = document.querySelector('.video iframe');

    const player = new Player(iframe);
    const btn = document.querySelector('.video-play');
    btn.addEventListener('click', () => {
      player.getPaused().then(function(paused) {
        if(paused){
          player.play();
        }else{
           player.pause();
        }
    
    });
    })
  }
}

export default vimeo;